import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../store";

export interface AppNoticeItem {
  enabled: boolean;
  loaded: boolean;
}

export interface AnnouncementMessage {
  en: string | null;
  fr: string | null;
  ar: string | null;
}

export interface AnnouncementNoticeItem extends AppNoticeItem {
  message: AnnouncementMessage;
  bgColor: string | null;
}

export interface AppNoticeState {
  maintenance: AppNoticeItem;
  announcement: AnnouncementNoticeItem;
}

const initialState: AppNoticeState = {
  maintenance: { enabled: false, loaded: false },
  announcement: {
    enabled: false,
    loaded: false,
    message: { en: null, fr: null, ar: null },
    bgColor: null,
  },
};

const appNoticeSlice = createSlice({
  name: "appNotice",
  initialState,
  reducers: {
    setMaintenanceState: (state, action: PayloadAction<boolean>) => {
      state.maintenance.enabled = action.payload;
      state.maintenance.loaded = true;
    },
    setAnnouncementState: (
      state,
      action: PayloadAction<{
        enabled: boolean;
        message?: AnnouncementMessage;
        bgColor?: string | null;
      }>
    ) => {
      state.announcement.enabled = action.payload.enabled;
      state.announcement.loaded = true;
      if (action.payload.message) {
        state.announcement.message = action.payload.message;
      }
      if (action.payload.bgColor !== undefined) {
        state.announcement.bgColor = action.payload.bgColor;
      }
    },
    setNoticesLoaded: state => {
      state.maintenance.loaded = true;
      state.announcement.loaded = true;
    },
    resetAppNotices: () => initialState,
  },
});

export const {
  setMaintenanceState,
  setAnnouncementState,
  setNoticesLoaded,
  resetAppNotices,
} = appNoticeSlice.actions;

export default appNoticeSlice.reducer;

export const selectMaintenanceFlag = (state: RootState) =>
  state.appNotice.maintenance;
export const selectAnnouncementFlag = (state: RootState) =>
  state.appNotice.announcement;
export const selectAppNoticesLoaded = (state: RootState) =>
  state.appNotice.maintenance.loaded && state.appNotice.announcement.loaded;
